import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Menu,
  MenuItem,
} from '@mui/material'
import { useContext, useState } from 'react'
import { BiMenu, BiTrash } from 'react-icons/bi'
import { FaPersonCircleCheck } from 'react-icons/fa6'
import { IoReload } from 'react-icons/io5'
import { LuSave } from 'react-icons/lu'
import dayjs from 'dayjs'
import { metodoPrograma } from '../../../../../../components/api'
import { AgendaContext } from '../../..'
import { GlobalContext } from '../../../../../../App'
import { setSuccess } from '../../../../../../components/alerts'

export function Actions({
  tpEstado,
  idAgendamento,
  dtExclusao,
  fecharModal,
  disableOpcoes,
}) {
  const { agendamentoSelecionado, dispatch } = useContext(AgendaContext)
  const { localAtendimento } = useContext(GlobalContext)
  const [anchorEl, setAnchorEl] = useState(null)
  const [openConfirmModal, setOpenConfirmModal] = useState(false)
  const mensageSendWhats = `Você confirma sua presença na consulta com a Clínica, agendada para o dia ${dayjs(agendamentoSelecionado.data?.[1]).format('DD/MM/YYYY')}, às ${dayjs(agendamentoSelecionado.data?.[1]).format('HH:mm')}?`

  const cancelaAgendamento = (idAgendamento) => {
    metodoPrograma('cancelaAgendamento', { idAgendamento }).then((res) => {
      if (res.status) {
        fecharModal()
      }
    })
  }

  const anunciaChegada = (idAgendamento, snEncaminharAoMedico) => {
    metodoPrograma('anunciaChegada', {
      idAgendamento,
      snEncaminharAoMedico,
    }).then((res) => {
      if (res.status) {
        fecharModal()
      }
    })
  }

  const handleSendWhatsApp = async () => {
    const nrTelefone = agendamentoSelecionado.data?.[14]
    const result = await metodoPrograma(
      'enviaWhats',
      {
        nrTelefone,
        idAgendamento: agendamentoSelecionado.data?.[0],
        dsMensagem: mensageSendWhats,
      },
      'CtrlAgendamento',
    )
    if (result.status) {
      setOpenConfirmModal(false)
      setSuccess('Mensagem enviada com sucesso!')
    }
  }
  const confirmaComparecimento = (idAgendamento, snEncaminharAoMedico) => {
    metodoPrograma('confirmaComparecimento', {
      idAgendamento,
      snEncaminharAoMedico,
    }).then(async (res) => {
      if (res.status) {
        dispatch({
          field: 'agendamentoSelecionado',
          value: { data: res.agendamento, modal: true },
        })
      }
    })
  }

  const finalizaAgendamento = (idAgendamento) => {
    metodoPrograma('finalizaAgendamento', {
      idAgendamento,
      idLocalAtendimento: localAtendimento[0],
    }).then((res) => {
      if (res.status) {
        fecharModal()
      }
    })
  }

  const reabrirAgendamento = (idAgendamento) => {
    metodoPrograma('reabrirAgendamento', {
      idAgendamento,
      idLocalAtendimento: localAtendimento[0],
    }).then((res) => {
      if (res.status) {
        fecharModal()
      }
    })
  }

  return (
    <div className="flex justify-end w-full gap-2">
      {idAgendamento && (
        <>
          {!dtExclusao &&
            (tpEstado === '1' || tpEstado === '2' || tpEstado === '3') && (
              <Button
                fullWidth
                startIcon={dtExclusao ? <IoReload /> : <BiTrash />}
                variant="contained"
                onClick={async () => cancelaAgendamento(idAgendamento)}
              >
                {dtExclusao ? 'Reativar' : 'Excluir'}
              </Button>
            )}
          {!dtExclusao && tpEstado === '5' && (
            <Button
              fullWidth
              startIcon={<FaPersonCircleCheck />}
              variant="contained"
              color="primary"
              onClick={() => finalizaAgendamento(idAgendamento)}
            >
              Finalizar
            </Button>
          )}
          {(tpEstado === '1' || tpEstado === '2') && (
            <Button
              fullWidth
              startIcon={<BiMenu />}
              variant="contained"
              disabled={disableOpcoes}
              onClick={async (event) => setAnchorEl(event.currentTarget)}
            >
              Opções
            </Button>
          )}
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}
          >
            <MenuItem
              disabled={agendamentoSelecionado.data?.[10]}
              onClick={() => confirmaComparecimento(idAgendamento, false)}
            >
              Confirmar Comparecimento
            </MenuItem>
            <MenuItem
              disabled={tpEstado === '3'}
              onClick={() => anunciaChegada(idAgendamento, true)}
            >
              Encaminhar ao Médico
            </MenuItem>
          </Menu>
        </>
      )}
      {!dtExclusao && tpEstado === '1' && (
        <Button
          fullWidth
          variant="contained"
          color="primary"
          type="submit"
          startIcon={<LuSave />}
        >
          Salvar
        </Button>
      )}

      {!dtExclusao && tpEstado === '6' && (
        <Button
          fullWidth
          startIcon={<FaPersonCircleCheck />}
          variant="contained"
          color="primary"
          onClick={() => reabrirAgendamento(idAgendamento)}
        >
          Reabrir
        </Button>
      )}
      <Dialog
        open={openConfirmModal}
        onClose={() => setOpenConfirmModal(false)}
      >
        <DialogTitle>Confirmar Envio da mensagem:</DialogTitle>
        <DialogContent>
          <p>{mensageSendWhats}</p>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpenConfirmModal(false)}
            color="error"
            variant="outlined"
          >
            Cancelar
          </Button>
          <Button
            onClick={handleSendWhatsApp}
            color="primary"
            variant="contained"
          >
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
